import { Col, Modal, Panel, Row } from '@elotech/components';
import React from 'react';
import { useEffect, useState } from 'react';

import { Informativo } from '../informativo';
import { InlineButton } from '../inline-button';

type Props = {
  open?: boolean;
  onValidate?: () => void;
  title?: string;
  message?: string;
  validateLabel?: string;
  reloadLabel?: string;
  maxWidth?: string;
};

type CaptchaModule = {
  LoadCanvasTemplate: React.ComponentType<{ reloadText?: string }>;
  loadCaptchaEnginge: (
    length: number,
    backgroundColor?: string,
    color?: string
  ) => void;
  validateCaptcha: (value: string, reload?: boolean) => boolean;
};

const getCaptchaModule = (): CaptchaModule =>
  require('react-simple-captcha') as CaptchaModule;

export const CaptchaModal: React.FC<Props> = ({
  open = false,
  onValidate,
  title = 'Validacao de seguranca',
  message = 'Antes de iniciar o cadastro, informe o captcha exibido abaixo.',
  validateLabel = 'Validar',
  reloadLabel = 'Recarregar captcha',
  maxWidth = '28%'
}) => {
  const [captchaValue, setCaptchaValue] = useState('');
  const [captchaError, setCaptchaError] = useState('');

  useEffect(() => {
    if (open) {
      const { loadCaptchaEnginge } = getCaptchaModule();
      loadCaptchaEnginge(6, '#f5f5f5', '#333');
      setCaptchaValue('');
      setCaptchaError('');
    }
  }, [open]);

  const reloadCaptcha = (clearError = true) => {
    const { loadCaptchaEnginge } = getCaptchaModule();
    loadCaptchaEnginge(6, '#f5f5f5', '#333');
    setCaptchaValue('');

    if (clearError) {
      setCaptchaError('');
    }
  };

  const handleValidateCaptcha = () => {
    const { validateCaptcha } = getCaptchaModule();

    if (validateCaptcha(captchaValue, false)) {
      setCaptchaError('');
      onValidate?.();
      return;
    }

    setCaptchaError('Captcha invalido. Tente novamente.');
    reloadCaptcha(false);
  };

  if (!open) {
    return null;
  }

  const { LoadCanvasTemplate } = getCaptchaModule();

  return (
    <>
      <style>{'.modal.open .container > .close { display: none; }'}</style>
      <Modal onClose={() => {}} maxWidth={maxWidth}>
        <Panel title={title} isForm>
          <Row>
            <Col md={12}>
              <p>{message}</p>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <LoadCanvasTemplate reloadText={reloadLabel} />
            </Col>
          </Row>
          <Row>
            <Col md={12} className="mt-xs">
              <label className="control-label" htmlFor="captcha-input">
                Captcha
              </label>
              <input
                id="captcha-input"
                className="form-control"
                value={captchaValue}
                onChange={event => setCaptchaValue(event.target.value)}
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    handleValidateCaptcha();
                  }
                }}
              />
            </Col>
          </Row>
          {captchaError && (
            <Row>
              <Col md={12}>
                <Informativo type="ERROR" withIcon classes="mt-xs">
                  {captchaError}
                </Informativo>
              </Col>
            </Row>
          )}
          <Row>
            <Col md={12} className="mt-xs">
              <InlineButton
                label={validateLabel}
                onClick={handleValidateCaptcha}
              />
            </Col>
          </Row>
        </Panel>
      </Modal>
    </>
  );
};
